<!--
 * @Author: Suroc
 * @Date: 2024-07-05 14:31:40
 * @LastEditTime: 2024-12-23 16:25:06
 * @Description: 
-->
<template>
  <div class="layout" :class="themeClass">
    <Header />
    <div class="contView" @scroll="scrollEvent">
      <!-- <transition name="routerView"> -->
      <RouterView />
      <!-- </transition> -->
    </div>
    <Footer />
    <SurocPrompt />
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router'
import { useThemeStore } from '@/stores/settings'
import Header from '@/layouts/header/index.vue'
import Footer from '@/layouts/footer/index.vue'

const themeStore = useThemeStore()
const themeClass = computed(() => themeStore.theme)
let scrollEvent = (event) => {
  const element = event.target
  const scrollTop = element.scrollTop
  // this.scrolltop = scrollTop
  // this.$store.dispatch('scroll/setScroll', scrollTop)
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
